import { combineReducers } from 'redux'
import botReducer from '../App/reducer'
import chatWidgetReducer from '../ChatWidget/store/reducers'

const rootReducer = combineReducers({
  bot: botReducer,
  widget: chatWidgetReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducer.js